
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/pages/styles.less?modules";
export default {"infoWrapper": `infoWrapper-1u-_nUE2`,"pageLoaderContainer": `pageLoaderContainer-Y080t4HZ`,"visible": `visible-Lfwpj4OZ`,"nonVisible": `nonVisible-OwkYTyFt`,"list": `list-IjdSSZCW`,"button": `button-HCwbNXge`,"logo": `logo-i6ELzqRr`}
